<div class="aw-dialog">
  <div class="aw-dialog-header" style="margin-bottom: 8px;">{{header}}</div>
  <div class="aw-dialog-sub-header" style="margin-bottom: 56px;">{{subHeader}}</div>

  <div class="button-group">
    <button class="aw-btn aw-btn-gray" style="margin-right: 8px;" (click)="cancel()">Cancel</button>
    <button class="aw-btn aw-btn-blue" (click)="confirm()">{{btnText}}</button>
  </div>
</div>
